<template>
  <Dropdown
    v-model="selectedOption"
    :options="menuSugerencias"
    optionLabel="label"
    filter
    filterPlaceholder="Filtrar"
    placeholder="Insertar"
    emptyFilterMessage="No se encontraron resultados"
    class="dropdown-for-inserts"
    @change="handleChange"
  >
    <template #option="slotProps">
      <div class="dropdown-for-inserts__option" :title="stringValue(slotProps.option.value)">
        {{ slotProps.option.label }}
      </div>
    </template>
  </Dropdown>
</template>

<script setup>
import { computed, ref } from "vue";
import Dropdown from "primevue/dropdown";

const emit = defineEmits(["insert"]);

const props = defineProps({
  menuSugerenciasProp: {
    type: Array,
  },
  data: {
    type: [Object, Array],
  },
  notInclude: {
    type: Array,
    default: () => [],
  },
});

const selectedOption = ref(null);

const menuSugerencias = computed(() => {
  const menu = [];
  const sourceData = props.data ?? {};

  for (const key in sourceData) {
    if (sourceData[key] == "") continue;
    if (!sourceData[key]) continue;
    if (typeof sourceData[key] == "string" && sourceData[key].search("</") >= 0) continue;
    if (props.notInclude.indexOf(key) >= 0) continue;

    if (typeof sourceData[key] != "object") {
      menu.push({
        label: capitalizeFirstLetter(decamelize(key, " ")),
        value: sourceData[key],
      });
      continue;
    }

    if (Array.isArray(sourceData[key])) {
      for (const nestedKey in sourceData[key]) {
        if (sourceData[key][nestedKey] == "") continue;
        if (!sourceData[key][nestedKey]) continue;
        if (
          typeof sourceData[key][nestedKey] == "string" &&
          sourceData[key][nestedKey].search("</") >= 0
        )
          continue;

        menu.push({
          label: capitalizeFirstLetter(decamelize(`${key} ${nestedKey}`, " ")),
          value: sourceData[key][nestedKey],
        });
      }
      continue;
    }

    for (const nestedKey in sourceData[key]) {
      if (sourceData[key][nestedKey] == "") continue;
      if (!sourceData[key][nestedKey]) continue;
      if (
        typeof sourceData[key][nestedKey] == "string" &&
        sourceData[key][nestedKey].search("</") >= 0
      )
        continue;

      menu.push({
        label: capitalizeFirstLetter(decamelize(nestedKey, " ")),
        value: sourceData[key][nestedKey],
      });
    }
  }

  return menu;
});

const handleChange = (event) => {
  const option = event.value;
  if (!option) return;

  emit("insert", option.value);
  selectedOption.value = null;
};

const decamelize = (str, separator = "_") => {
  return str
    .replace(/([a-z\d])([A-Z])/g, "$1" + separator + "$2")
    .replace(/([A-Z]+)([A-Z][a-z\d]+)/g, "$1" + separator + "$2")
    .toLowerCase();
};

const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

const stringValue = (value) => {
  return value == null ? "" : String(value);
};
</script>

<style scoped>
.dropdown-for-inserts {
  min-width: 14rem;
}

.dropdown-for-inserts__option {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
